<template>
  <div class="w120 mc mt20 mb20">
    <div class="po-f font-16 nav-box">
      <p :class="{ active: active === 0 }" @click="scrollTo(0)">流程信息</p>
      <p :class="{ active: active === 1 }" @click="scrollTo(1)">办理方式</p>
      <p :class="{ active: active === 2 }" @click="scrollTo(2)">办理材料</p>
      <p :class="{ active: active === 3 }" @click="scrollTo(3)">办理流程</p>
      <p :class="{ active: active === 4 }" @click="scrollTo(4)">注意事项</p>
      <p :class="{ active: active === 5 }" @click="scrollTo(5)">常见问题</p>
      <p :class="{ active: active === 6 }" @click="scrollTo(6)">服务评价</p>
    </div>

    <div id="detailMain" class="w100 detail-main">
      <div class="w100 pt20 pb20 pl20 pr20 bg-w">
        <p class="font-22 mb10">学生请假</p>

        <div class="nav-content">
          <p class="title font-18">流程信息</p>
          <table class="mt20 mb20 w100 detail-table">
            <tr>
              <td>服务对象</td>
              <td>学生</td>
              <td>归属部门</td>
              <td>学工处</td>
              <td>联系人</td>
              <td>张三</td>
            </tr>
            <tr>
              <td>审批人</td>
              <td>院长</td>
              <td>办理时间</td>
              <td>全天</td>
              <td>联系方式</td>
              <td>15963520210</td>
            </tr>
            <tr>
              <td>申请方式</td>
              <td>在线申请</td>
              <td>办理地点</td>
              <td>教学楼</td>
              <td>监管部门</td>
              <td>纪检部</td>
            </tr>
            <tr>
              <td>申请条件</td>
              <td>身体不适</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>

        <div class="nav-content">
          <p class="title font-18">办理方式</p>
          <p class="w100 mt10 tx-c font-18 title-2">办理方式</p>
          <table class="mt10 mb20 w100 detail-table">
            <tr>
              <td>办理时间</td>
              <td>全天</td>
            </tr>
            <tr>
              <td>办理地点</td>
              <td>线上</td>
            </tr>
            <tr>
              <td>办理材料</td>
              <td>如果有病假，需要上传病假单附件。</td>
            </tr>
            <tr>
              <td>收费方式</td>
              <td>不收费</td>
            </tr>
          </table>
          <p class="w100 mt10 tx-c font-18 title-2">线下办理</p>
          <table class="mt10 mb20 w100 detail-table">
            <tr>
              <td>办理时间</td>
              <td>工作日9:00--18:00</td>
            </tr>
            <tr>
              <td>办理地点</td>
              <td>行政办公室</td>
            </tr>
            <tr>
              <td>办理材料</td>
              <td>如果有病假，需要上传病假单附件。</td>
            </tr>
            <tr>
              <td>收费方式</td>
              <td>不收费</td>
            </tr>
          </table>
        </div>

        <div class="nav-content">
          <p class="mb10 title font-18">办理材料</p>
          <div class="pl10 pr10 pt10 pb10 bor-b flex-box hover hover-bg">
            <div class="flex-1 flex-box al-c">
              <i class="font-20 green el-icon-picture"></i>
              <span class="ml10 font-14 ellipsis">病假单.jpg</span>
            </div>
            <div>
              <el-button size="mini" type="primary">在线预览</el-button>
              <el-button size="mini" type="success">下载</el-button>
            </div>
          </div>
          <div class="pl10 pr10 pt10 pb10 bor-b flex-box hover hover-bg">
            <div class="flex-1 flex-box al-c">
              <i class="font-20 green el-icon-picture"></i>
              <span class="ml10 font-14 ellipsis">病假单.jpg</span>
            </div>
            <div>
              <el-button size="mini" type="primary">在线预览</el-button>
              <el-button size="mini" type="success">下载</el-button>
            </div>
          </div>
          <div class="pl10 pr10 pt10 pb10 bor-b flex-box hover hover-bg">
            <div class="flex-1 flex-box al-c">
              <i class="font-20 green el-icon-picture"></i>
              <span class="ml10 font-14 ellipsis">病假单.jpg</span>
            </div>
            <div>
              <el-button size="mini" type="primary">在线预览</el-button>
              <el-button size="mini" type="success">下载</el-button>
            </div>
          </div>
        </div>

        <div class="mt20 nav-content">
          <p class="mb10 title font-18">办理流程</p>
          <div class="pt20 pb20 pl20 pr20">
            <el-image class="w100" :src="`${baseUrl}/images/hcxy-liucheng.png`" :preview-src-list="[`${baseUrl}/images/hcxy-liucheng.png`]"></el-image>
          </div>
        </div>

        <div class="mt20 nav-content">
          <p class="mb10 title font-18">注意事项</p>
          <div class="pt10 pb20 pl20 pr20">
            <p class="font-16">及时提交请假申请，补交请假申请的时间不能超过请假后一周。</p>
          </div>
        </div>

        <div class="mt20 nav-content">
          <p class="mb10 title font-18">常见问题</p>
          <div class="pt10 pb20 pl20 pr20">
            <div class="mb20">
              <p class="mb10 font-16">1.请假需要离校的如何办理？</p>
              <p class="mb10 font-16">答：需要离校的需要填写对应的离校申请单。</p>
            </div>
            <div class="mb20">
              <p class="mb10 font-16">2.病假条是否需要医院盖章，诊所签字的是否也可以？</p>
              <p class="mb10 font-16">答：最好提交医院盖章的病假条，一般医院都能提供，如果确实是诊所的，提供诊所的个人签章也行。</p>
            </div>
          </div>
        </div>

        <div class="mt20 nav-content">
          <p class="mb10 title font-18">服务评价</p>
          <div class="pt20 pb20 pl20 pr20">
            <div class="flex-box score-box">
              <div class="pl10 pr10 flex-2">
                <p class="mb10 font-14">评价次数</p>
                <p class="">
                  <span class="font-40">2540</span>
                  <span class="ml5 font-14">次</span>
                </p>
              </div>
              <div class="pl10 pr10 flex-2">
                <p class="mb10 font-14">好评次数</p>
                <p class="">
                  <span class="font-40">1840</span>
                  <span class="ml5 font-14">次</span>
                </p>
              </div>
              <div class="pl10 pr10 flex-2">
                <p class="mb10 font-14">办理时效</p>
                <p class="">
                  <span class="font-40">16.5</span>
                  <span class="ml5 font-14">小时</span>
                </p>
              </div>
              <div class="pl10 pr10 flex-3">
                <p class="mb10 font-14">办理评分</p>
                <p class="flex-box al-b">
                  <span class="font-40">4.8</span>
                  <span class="ml5 pb5 font-14">分</span>
                  <span class="ml10 pb5">
                    <el-rate :value="4.5" disabled></el-rate>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="w100" style="height: 80px;">
          <div id="launchBox" class="flex-box al-c bg-w launch-box" :class="sticky ? 'launch-box-fix' : ''">
            <div class="ml20 tx-c cu-p">
              <i class="font-28 myfont icon-iconfontxihuan"></i>
              <p class="font-14">我要收藏</p>
            </div>
            <div class="flex-1"></div>
            <div class="ml20 tx-c">
              <el-rate :value="4.5" disabled></el-rate>
              <p class="font-14">3520次办理 4星服务</p>
            </div>
            <div class="ml20 mr20">
              <el-button type="primary" size="medium">我要办理</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Test",
  props: [],
  components: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      active: 0,
      sticky: true,
    };
  },
  computed: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      // 记录nav的active锚点
      const navContents = document.querySelectorAll(".nav-content");
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop - 150);
      });
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      let navIndex = 0;
      for (let i = 0; i < offsetTopArr.length; i++) {
        if (scrollTop >= offsetTopArr[i]) {
          navIndex = i;
        }
      }
      this.active = navIndex;

      // 此处开始计算底部办理的粘性布局
      const detailMain = document.getElementById("detailMain");
      const detailMainTop =
        detailMain.offsetTop +
        detailMain.clientHeight -
        20 -
        window.innerHeight;
      if (scrollTop < detailMainTop) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }
    },
    scrollTo(index) {
      // 因为第一个.nav-content是父元素的第二个子元素，第一个是p标签，并且nth-child从1开始计数，所以从2开始对应该元素锚点
      const targetOffsetTop =
        document.querySelector(`.nav-content:nth-child(${index + 2})`)
          .offsetTop - 80;

      document.body.scrollTop = targetOffsetTop;
      document.documentElement.scrollTop = targetOffsetTop;

      setTimeout(() => {
        this.active = index;
      }, 30);
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped>
.nav-box {
  top: 90px;
  left: calc(50% - 600px);
  border-right: 1px solid #eeeeee;
  z-index: 10;
}

.nav-box p {
  position: relative;
  margin: 10px 0;
  padding: 5px 20px 5px 5px;
  cursor: pointer;
}

.nav-box p.active {
  color: #074677;
}

.nav-box p.active::before {
  display: block;
  position: absolute;
  content: "";
  right: 0;
  top: calc(50% - 2px);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #074677;
}

.detail-main {
  padding: 0 0 0 110px;
}

.title {
  position: relative;
  padding: 10px 0 10px 10px;
  color: #074676;
  border-bottom: 1px solid #f5f5f5;
}

.title::before {
  display: block;
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  width: 5.3em;
  height: 2px;
  background: #074677;
}

.detail-table {
  border-collapse: collapse;
}

.detail-table td {
  padding: 10px 5px;
  text-align: center;
  font-size: 14px;
  background: #ffffff;
  border: 1px solid #4d8bba;
}

.detail-table tr td:nth-child(odd) {
  background: #e9f3fa;
}

.title-2 {
  color: #074677;
}

.score-box {
  padding: 30px 20px 20px 20px;
  background: #e8f2fa;
}

.launch-box {
  width: 1050px;
  height: 80px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.launch-box-fix {
  position: fixed;
  bottom: 0;
  left: calc(50% - 470px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
